import MenuPhoto from "../components/MenuPhoto";
import Corporate from "../components/Photographie/Corporate";
import Evenements from "../components/Photographie/Evenements";
import FormHome from "../components/FormHome";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const Photographie = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const section = searchParams.get('section');
        if (section) {
            setTimeout(() => {
                const el = document.getElementById(section);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 800);
        }
    }, [searchParams]);

    return (
        <>
            <MenuPhoto />

            {/* Header */}
            <header className="min-[320px]:px-4 xl:px-16 min-[320px]:pt-10 xl:pt-20 pb-8 text-center">
                <h1 className="text-4xl xl:text-[40px] font-bold tracking-tight mb-4">
                    La photographie au service de votre image
                </h1>
                <p className="text-base xl:text-[16px] max-w-2xl mx-auto">
                    Nous accompagnons les entreprises dans la réalisation de contenus photographiques adaptés à leurs besoins, qu’il s’agisse de communication corporate ou de couverture événementielle.<br/><br/>
                    Portraits, reportages, mises en situation ou captation d’événements : chaque image est pensée pour valoriser votre identité et retranscrire fidèlement vos moments clés.
                </p>
            </header>

            <div className="min-[320px]:px-4 xl:px-16 min-[320px]:pt-14 xl:pt-28">
                <Corporate />
                <Evenements />
            </div>

            <FormHome />
        </>
    );
};

export default Photographie;